import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { Camera } from '../pages/camera-realtime-map/models';


@Injectable({
  providedIn: 'root'
})
export class CameraService {

  constructor(
    private http: HttpClient) { }

  async getCameras(deviceId: number): Promise<Camera[]> {
    const response = await this.http.post('/DeviceLiveLocation.aspx?endpoint=getcamerasfordevice&deviceId=' + deviceId, null);
    const cameras = await lastValueFrom(response) as Camera[];
    return cameras;
  }

  async getStream(camera: Camera): Promise<string> {
    const response = await this.http.post('/DeviceLiveLocation.aspx?endpoint=getstreamurl&cameraId=' + camera.userId, null);
    const stream = await lastValueFrom(response) as string;
    return stream;
  };

}
